/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import Tooltip from '../../../../../common/components/core/Tooltip';
import Link from '../../../../../common/components/core/Link';
import QueryBuilder from '../../QueryBuilder';
export const generateStatusLabel = (status: string): React.ReactElement<any> | null | undefined => {
  if (!status) {
    return null;
  }

  status = status.toUpperCase();

  switch (status) {
    case 'ACTIVE':
      return <span className="journey-status-label label-success">ACTIVE</span>;

    case 'DRAFT':
      return <span className="journey-status-label label-info">DRAFT</span>;

    case 'PAUSED':
      return <span className="journey-status-label label-warning">STOPPED</span>;

    case 'SCHEDULED':
      return <span className="journey-status-label label-scheduled">SCHEDULED</span>;

    case 'ARCHIVED':
      return <span className="journey-status-label label-default">ARCHIVED</span>;

    case 'TRIAL':
      return <span className="journey-status-label label-trial">TRIAL</span>;

    case 'INACTIVE':
      return <span className="journey-status-label label-inactive">INACTIVE</span>;

    default:
      return <span className="journey-status-label">{status}</span>;
  }
};
export const AMPJourneysTooltipBody = (
  <span>
    Unavailable for AMP Web Journeys.{' '}
    <Link href="https://docs.branch.io/pages/web/journeys/#examples" testid="learn-more__amp-journeys">
      Learn More
    </Link>
    .
  </span>
);
export class AMPJourneysTooltip extends React.PureComponent<{}> {
  render() {
    return <Tooltip body={AMPJourneysTooltipBody} />;
  }
}
export const getUrlPlaceholderAndTooltip = (
  matching: string
): {
  urlPlaceholder: string;
  tooltipText: React.ReactElement<any>;
} => {
  let urlPlaceholder;
  let tooltipText;

  switch (matching) {
    case QueryBuilder.STARTS_WITH:
    case QueryBuilder.NOT_STARTS_WITH:
      urlPlaceholder = 'http://www.example.com/abc/';
      tooltipText = (
        <div>
          <p>
            The url entered must match the beginning of the page url exactly. Please note that Branch will ignore the URL
            fragment (e.g. #example) when applying rules, so please do not create rules with a URL fragment (#).
          </p>
          <p>
            To add multiple urls, hit enter after each. This filter will work if any of the provided urls match the beginning
            of the page url.
          </p>
        </div>
      );
      break;

    case QueryBuilder.CONTAINING:
    case QueryBuilder.NOT_CONTAINING:
      urlPlaceholder = 'path/to/content';
      tooltipText = (
        <div>
          <p>The path segment entered must be contained in the page url's path.</p>
          <p>
            To add multiple path segments, hit enter after each. This filter will work if any of the provided segments are
            contained in the page url.
          </p>
          <p>
            This rule only matches the url path, not including the domain or query params. To filter by domain or query
            param, use 'whose domain matches' or 'with query param key' filters.
          </p>
        </div>
      );
      break;

    case QueryBuilder.NOT_QUERY_PARAM:
      urlPlaceholder = 'abc';
      tooltipText = (
        <div>
          <p>Use this to filter out urls with specific query parameters.</p>
          <p>For example if you have a url that looks like this:</p>
          <pre>http://example.com?product=abc</pre>
          <p>Set a filter with a query param key:</p>
          <pre>product</pre>
          <p>and query param value:</p>
          <pre>abc</pre>
          <p>to exclude this page from being shown the Journey</p>
        </div>
      );
      break;

    case QueryBuilder.QUERY_PARAM:
      urlPlaceholder = 'abc';
      tooltipText = (
        <div>
          <p>Use this to filter on url query parameters.</p>
          <p>For example if you have a url that looks like this:</p>
          <pre>http://example.com?product=abc</pre>
          <p>Set a filter with a query param key:</p>
          <pre>product</pre>
          <p>and query param value:</p>
          <pre>abc</pre>
          <p>to match this url</p>
        </div>
      );
      break;

    case QueryBuilder.DOMAIN_NOT_MATCHING:
    case QueryBuilder.DOMAIN_MATCHING:
      urlPlaceholder = 'branch.io';
      tooltipText = (
        <div>
          <p>The domain entered must match the url's domain exactly, not including http:// or https://.</p>
          <p>
            To add multiple domains, hit enter after each. This filter will work if any of the provided domain match the page
            domain.
          </p>
        </div>
      );
      break;

    default:
      urlPlaceholder = 'http://www.example.com/';
      tooltipText = (
        <div>
          <p>
            The url entered must match the page url exactly. We recommend that you copy the desired url directly from your
            browser’s url input box. Please note that Branch will ignore the URL fragment (e.g. #example) when applying
            rules, so please do not create rules with a URL fragment (#).
          </p>
          <p>
            To add multiple urls, hit enter after each. This filter will work if any of the provided urls match the page url.
          </p>
        </div>
      );
      break;
  }

  return {
    urlPlaceholder,
    tooltipText,
  };
};
export const JourneysFilterTooltipBody = () => (
  <span>
    Branch relies on its own data about device-level app interactions to identify users who have visited the app before.
    Learn more{' '}
    <Link href="https://docs.branch.io/web/journeys/#has_app-limitations" testid="learn-more__filter-journeys">
      here
    </Link>
    .
  </span>
);
